import { toast } from "./toast";

/**
 * <table data-kit-grid data-kit-unique="to">: picking a value in that column that another row already has warns at once
 * (e.g. the same destination twice in a party rate list). Save still refuses it; this only saves a round trip.
 */
document.addEventListener("kit:accepted", (e) => {
  const input = e.target as HTMLInputElement;
  const grid = input.closest<HTMLTableElement>("table[data-kit-unique]");
  const col = grid?.dataset.kitUnique;
  if (!grid || !col || input.dataset.kitCol !== col) return;
  const picked = (e as CustomEvent<{ id: string; text: string }>).detail;
  // Each row's picked id sits in the hidden field its lookup fills (data-kit-ac-target).
  const idOf = (tr: HTMLTableRowElement) => {
    const target = tr.querySelector<HTMLInputElement>(`input[data-kit-col='${col}']`)?.dataset.kitAcTarget;
    if (!target) return undefined;
    const prop = target.split(".").pop(); // new rows are renumbered from the Rows[#] template, as autocomplete.ts allows
    return tr.querySelector<HTMLInputElement>(`input[name='${target}'], input[name$='.${prop}']`)?.value;
  };
  const mine = input.closest("tr");
  const other = Array.from(grid.tBodies[0]?.rows ?? []).findIndex((tr) => tr !== mine && idOf(tr) === picked.id);
  if (other < 0) { input.removeAttribute("aria-invalid"); return; }
  input.setAttribute("aria-invalid", "true");
  toast("warn", `${picked.text} is already in the list (row ${other + 1})`);
});
